import React, { useEffect, useState } from "react"
import TableComponent from 'components/shared/TableComponent'
import { getUccSearchTableData } from 'actions/applicants'
import { uccSearchTableColumns } from 'constants/application'
import Button from 'components/shared/Button'
import strings from 'strings'
import UccSearchDrawer from "./UccSearchDrawer"
import AuthService from "../../../../../../../tools/AuthService";
import {useHistory} from "react-router-dom";
import queryString from "query-string";

const UccSearch = ({ applicationId, debtorApplication, creditUsageEnabled, creditCosts }) => {

    const [selectedRow, setSelectedRow] = useState(null)
    const [openUccSearchDrawer, setOpenUccSearchDrawer] = useState(false)
    const [uccList, setUccList] = useState([])
    const history = useHistory()
    const { uccDrawerTab, uccSearchId } = queryString.parse(history.location.search)
    const [loadingTableData, setLoadingTableData] = useState(false)
    const [tabValue, setTabValue] = useState(0)
    const { isReadOnlyUser } = AuthService.getClientFeatures()

    useEffect(() => {
        setLoadingTableData(true)
        updateUccSearchTableData()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        const { uccDrawerTab, uccEntity } = queryString.parse(history.location.search)
        if (uccDrawerTab === 'history' && uccList.length > 0 && !openUccSearchDrawer) {
            const entity = (uccEntity && uccList.find(e => e.uuid === uccEntity)) || uccList[0]
            setSelectedRow(entity)
            setTabValue(2)
            setOpenUccSearchDrawer(true)
        }
    }, [uccList, history.location.search])

    // update ucc search table data
    const updateUccSearchTableData = () => {
        getUccSearchTableData({ applicationId })
            .then(setUccList)
            .finally(() => { setLoadingTableData(false) })
    }

    // handle onClose drawer
    const handleOnClose = () => {
        setOpenUccSearchDrawer(false)
        updateUccSearchTableData()

        const params = queryString.parse(history.location.search)
        delete params.uccDrawerTab
        delete params.uccEntity
        delete params.uccEntityType  // ← add
        delete params.uccSearchId    // ← add
        const cleanSearch = queryString.stringify(params)
        history.replace(`${history.location.pathname}${cleanSearch ? `?${cleanSearch}` : ''}`)
    }

    const handleButtonClick = (row) => {
        const status = row?.statusLabel?.status
        setSelectedRow(row)
        if (status === 'Not Started') {
            setTabValue(0)
        } else if (row?.numberOfFilingsSaved > 0){
            setTabValue(1)
        } else {
            setTabValue(2)
        }
        setOpenUccSearchDrawer(true)
    }

    const openSearchAction = {
            formatter: (cell, row) => {
                const buttonText = row?.statusLabel?.status === 'Not Started' ? strings.SEARCH : strings.VIEW
                const variant = row?.statusLabel?.status === 'Not Started' ? 'contained' : 'outlined'
                return <Button
                    disable={(isReadOnlyUser && buttonText === strings.SEARCH)}
                    className={'minWidthButton'}
                    color='primary'
                    size={'small'}
                    variant={variant}
                    onClick={()=> handleButtonClick(row)}>
                    <p className='buttonText'>{buttonText}</p>
                </Button>
            }
        }

    uccSearchTableColumns.map((item, index) => {
        if (item.dataField === 'action') {
            uccSearchTableColumns[index] = {...item, ...openSearchAction}
        }
        return item
    })

    return (
        <>
            <TableComponent
                title={`${strings.UCC} ${strings.SEARCH}`}
                keyField='uuid'
                columns={uccSearchTableColumns}
                data={uccList}
                showPagination={false}
                isLoading={loadingTableData}
            />
            {
                openUccSearchDrawer &&
                <UccSearchDrawer
                    open={openUccSearchDrawer}
                    selectedEntity={selectedRow}
                    handleOnClose={handleOnClose}
                    applicationId={applicationId}
                    initialTab={tabValue}
                    debtorApplication={debtorApplication}
                    creditUsageEnabled={creditUsageEnabled}
                    creditCosts={creditCosts}
                    highlightSearchId={uccSearchId}
                />
            }
        </>
    )
}

export default UccSearch